import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  // history: createWebHashHistory(import.meta.env.BASE_URL),
  scrollBehavior() {
    return { top: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        title: "CoMake | Let's Make Together"
      },
      component: () => import('@/pages/HomePage.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('@/pages/ContactPage.vue'),
      meta: {
        title: 'Contact | CoMake'
      }
    },
    {
      path: '/devices',
      name: 'devices',
      component: () => import('@/shared/ui/layouts/DeviceLayout.vue'),
      meta: {
        title: 'Devices | CoMake'
      },
      redirect: '/devices/robots',
      children: [
        {
          path: 'robots',
          name: 'devices-robots',
          component: () => import('@/pages/devices/RobotsPage.vue')
        },
        {
          path: 'cameras',
          name: 'devices-cameras',
          component: () => import('@/pages/devices/CamerasPage.vue')
        },
        {
          path: 'video-transmission',
          name: 'devices-video-transmission',
          component: () => import('@/pages/devices/VideoTransmissionPage.vue')
        },
        {
          path: 'wireless-communication',
          name: 'devices-wireless-communication',
          component: () => import('@/pages/devices/WirelessCommunicationPage.vue')
        }
      ]
    },
    {
      path: '/demo',
      name: 'demo',
      component: () => import('@/shared/ui/layouts/DemoLayout.vue'),
      meta: {
        title: 'Demo | CoMake'
      },
      redirect: '/demo/control/puppy-pi',
      children: [
        {
          path: 'control',
          name: 'demo-control',
          redirect: '/demo/control/puppy-pi',
          children: [
            {
              path: 'puppy-pi',
              name: 'demo-control-puppy-pi',
              component: () => import('@/pages/control/PuppyPiPage.vue')
            },
            {
              path: 'spider-pi',
              name: 'demo-control-spider-pi',
              component: () => import('@/pages/control/SpiderPiPage.vue')
            },
            {
              path: 'deep-think-car',
              name: 'demo-control-deep-think-car',
              component: () => import('@/pages/control/DeepThinkCarPage.vue')
            },
            {
              path: 'telescope',
              name: 'demo-control-telescope',
              component: () => import('@/pages/control/TelescopePage.vue')
            },
            {
              path: 'rumi-car',
              name: 'demo-control-rumi-car',
              component: () => import('@/pages/control/RumiCarPage.vue')
            },
            {
              path: 'moth-car',
              name: 'demo-control-moth-car',
              component: () => import('@/pages/control/MothCarPage.vue')
            },
            {
              path: 'lego-cobot',
              name: 'demo-control-lego-cobot',
              component: () => import('@/pages/control/LegoCobotPage.vue')
            },
            {
              path: 'scout-mini',
              name: 'demo-control-scout-mini',
              component: () => import('@/pages/control/ScoutMiniPage.vue')
            },
            {
              path: 'hand-pi',
              name: 'demo-control-hand-pi',
              component: () => import('@/pages/control/HandPiPage.vue')
            },
            {
              path: 'video-keyboard-control',
              name: 'demo-control-video-keyboard-control',
              component: () => import('@/pages/control/VideoKeyboardPage.vue')
            }
          ]
        },
        {
          path: 'sample',
          name: 'demo-sample',
          redirect: '/demo/sample/broadcast/audio',
          children: [
            /* BROADCAST */
            {
              path: 'broadcast',
              name: 'demo-samples-broadcast',
              redirect: '/demo/sample/broadcast/audio',
              children: [
                {
                  path: 'audio',
                  name: 'demo-samples-audio',
                  component: () => import('@/pages/samples/broadcast/AudioPage.vue')
                },
                {
                  path: 'video',
                  name: 'demo-samples-video',
                  component: () => import('@/pages/samples/broadcast/VideoPage.vue')
                },
                {
                  path: 'media',
                  name: 'demo-samples-media',
                  component: () => import('@/pages/samples/broadcast/MediaPage.vue')
                },
                {
                  path: 'multiVideoPub',
                  name: 'demo-samples-multi-video-pub',
                  component: () => import('@/pages/samples/broadcast/MultiVideoPubPage.vue')
                },
                {
                  path: 'multiVideoSub',
                  name: 'demo-samples-multi-video-sub',
                  component: () => import('@/pages/samples/broadcast/MultiVideoSubPage.vue')
                },
                {
                  path: 'videoTime',
                  name: 'demo-samples-video-time',
                  component: () => import('@/pages/lab/VideoTimePage.vue')
                }
              ]
            },
            /* CHAT */
            {
              path: 'chat',
              name: 'demo-samples-chat',
              redirect: '/demo/sample/chat/messageChat',
              children: [
                {
                  path: 'messageChat',
                  name: 'demo-samples-message-chat',
                  component: () => import('@/pages/samples/chat/MessagePage.vue')
                },
                {
                  path: 'fileChat',
                  name: 'demo-samples-file-chat',
                  component: () => import('@/pages/samples/chat/FilePage.vue')
                }
              ]
            },
            /* CONTROL */
            {
              path: 'control',
              name: 'demo-samples-control',
              redirect: '/demo/sample/control/keyboardControl',
              children: [
                {
                  path: 'keyboardControl',
                  name: 'demo-samples-keyboard-control',
                  component: () => import('@/pages/samples/control/KeyboardPage.vue')
                },
                {
                  path: 'gamepadControl',
                  name: 'demo-samples-gamepad-control',
                  component: () => import('@/pages/samples/control/GamepadPage.vue')
                },
                {
                  path: 'speechControl',
                  name: 'demo-samples-speech-control',
                  component: () => import('@/pages/samples/control/SpeechPage.vue')
                },
                {
                  path: 'handGestureControl',
                  name: 'demo-samples-hand-gesture-control',
                  component: () => import('@/pages/samples/control/HandGesturePage.vue')
                },
                {
                  path: 'handPoseControl',
                  name: 'demo-samples-hand-pose-control',
                  component: () => import('@/pages/samples/control/HandPosePage.vue')
                },
                {
                  path: 'faceDetectionControl',
                  name: 'demo-samples-face-detection-control',
                  component: () => import('@/pages/samples/control/FaceDetectionPage.vue')
                }
                // {
                //   path: 'swarmControl',
                //   name: 'samples-swarmControl',
                //   component: () => import('@/pages/samples/control/SwarmControlPage.vue')
                // },
              ]
            },
            /* APPLICATIONS */
            {
              path: 'applications',
              name: 'demo-samples-applications',
              redirect: '/demo/sample/applications/imageCapture',
              children: [
                {
                  path: 'imageCapture',
                  name: 'demo-samples-image-capture',
                  component: () => import('@/pages/samples/applications/ImageCapturePage.vue')
                },
                {
                  path: 'retryConnect',
                  name: 'demo-samples-retry-connect',
                  component: () => import('@/pages/samples/applications/RetryConnectPage.vue')
                },
                {
                  path: 'sensor',
                  name: 'demo-samples-sensor',
                  component: () => import('@/pages/samples/applications/SensorPage.vue')
                },
                {
                  path: 'lidarVisualization',
                  name: 'demo-samples-lidar-visualization',
                  component: () => import('@/pages/samples/applications/LidarVisualizationPage.vue')
                },
                {
                  path: '360Video',
                  name: 'demo-samples-360-video',
                  component: () => import('@/pages/samples/applications/360VideoPage.vue')
                },
                {
                  path: 'codrive/carlaDriver',
                  name: 'demo-samples-carla-driver',
                  component: () => import('@/pages/samples/codrive/CarlaDriverPage.vue')
                },
                {
                  path: 'codrive/carlaSpectator',
                  name: 'demo-samples-carla-spectator',
                  component: () => import('@/pages/samples/codrive/CarlaSpectatorPage.vue')
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: '/projects',
      name: 'projects',
      component: () => import('@/shared/ui/layouts/ProjectLayout.vue'),
      meta: {
        title: 'Projects | CoMake'
      },
      redirect: '/projects/co-drive/simulator',
      children: [
        {
          path: 'co-drive',
          name: 'projects-codrive',
          redirect: '/projects/co-drive/simulator',
          children: [
            {
              path: 'simulator',
              name: 'projects-codrive-simulator',
              component: () => import('@/pages/projects/codrive/SimulatorPage.vue')
            },
            {
              path: 'simulator-driver',
              name: 'projects-codrive-simulator-driver',
              component: () => import('@/pages/projects/codrive/DriverSimulatorPage.vue')
            },
            {
              path: 'simulator-drone',
              name: 'projects-codrive-simulator-drone',
              component: () => import('@/pages/projects/codrive/DroneSimulatorPage.vue')
            },
            {
              path: 'smart',
              name: 'projects-codrive-smart',
              component: () => import('@/pages/projects/codrive/SmartPage.vue')
            },
            {
              path: 'surround',
              name: 'projects-codrive-surround',
              component: () => import('@/pages/projects/codrive/SurroundPage.vue')
            },
            {
              path: 'around',
              name: 'projects-codrive-around',
              component: () => import('@/pages/projects/codrive/AroundPage.vue')
            },
            {
              path: '360-control',
              name: 'projects-codrive-360-control',
              component: () => import('@/pages/projects/codrive/360ViewControlPage.vue')
            },
            {
              path: 'vslam',
              name: 'projects-codrive-vslam',
              component: () => import('@/pages/projects/codrive/VSLAMPage.vue')
            }
          ]
        },
        {
          path: 'ship',
          name: 'projects-ship',
          redirect: '/projects/ship/ship-monitoring',
          children: [
            {
              path: 'ship-monitoring',
              name: 'projects-ship-monitoring',
              component: () => import('@/pages/projects/ship/ShipMonitorPage.vue'),
              meta: { hideHeader: true }
            },
            {
              path: 'maritime-monitoring',
              name: 'projects-maritime-monitoring',
              component: () => import('@/pages/projects/ship/MaritimeMonitorPage.vue'),
              meta: { hideHeader: true }
            }
          ]
        }
      ]
    },
    {
      path: '/ai',
      name: 'ai',
      component: () => import('@/shared/ui/layouts/AILayout.vue'),
      meta: {
        title: 'AI | CoMake'
      },
      redirect: '/ai/language',
      children: [
        {
          path: 'language',
          name: 'ai-language',
          component: () => import('@/pages/ai/LanguageAIListPage.vue'),
          meta: {
            hideHeader: false
          },
          children: [
            {
              path: 'llm',
              name: 'ai-language-llm',
              component: () => import('@/pages/ai/LLMPage.vue'),
              meta: { hideHeader: true }
            },
            {
              path: 'vlm',
              name: 'ai-language-vlm',
              component: () => import('@/pages/ai/VLMPage.vue'),
              meta: { hideHeader: true }
            }
          ]
        },
        {
          path: 'audio',
          name: 'ai-audio',
          component: () => import('@/pages/ai/AudioAIListPage.vue'),
          meta: { hideHeader: false },
          children: [
            {
              path: 'asr',
              name: 'ai-audio-asr',
              component: () => import('@/pages/ai/ASRPage.vue'),
              meta: { hideHeader: true }
            },
            {
              path: 'tts',
              name: 'ai-audio-tts',
              component: () => import('@/pages/ai/TextToSpeechPage.vue'),
              meta: { hideHeader: true }
            }
            // {
            //   path: 'whisper',
            //   name: 'ai-audio-whisper',
            //   component: () => import('@/pages/ai/audio/WhisperPage.vue'),
            // },
            // {
            //   path: 'whisper-gpu',
            //   name: 'ai-audio-whisper-gpu',
            //   component: () => import('@/pages/ai/audio/WhisperGPUPage.vue'),
            // }
          ]
        },
        {
          path: 'vision',
          name: 'ai-vision',
          component: () => import('@/pages/ai/VisionAIListPage.vue'),
          children: [
            {
              path: 'face-detection',
              name: 'ai-vision-face-detection',
              component: () => import('@/pages/ai/FaceDetectionPage.vue'),
              meta: { hideHeader: true }
            },
            {
              path: 'hand-gesture-recognition',
              name: 'vision-hand-gesture-recognition',
              component: () => import('@/pages/ai/HandGestureRecognitionPage.vue'),
              meta: { hideHeader: true }
            },
            {
              path: 'hand-landmark-detection',
              name: 'ai-vision-hand-landmark-detection',
              component: () => import('@/pages/ai/HandLandmarkDetectionPage.vue'),
              meta: { hideHeader: true }
            },
            {
              path: 'object-detection',
              name: 'ai-vision-object-detection',
              component: () => import('@/pages/ai/ObjectDetectionPage.vue'),
              meta: { hideHeader: true }
            },
            {
              path: 'object-segmentation',
              name: 'ai-vision-object-segmentation',
              component: () => import('@/pages/ai/ObjectSegmentation.vue'),
              meta: { hideHeader: true }
            },
            {
              path: 'depth-estimation',
              name: 'ai-vision-depth-estimation',
              component: () => import('@/pages/ai/DepthEstimationPage.vue'),
              meta: { hideHeader: true }
            },
            {
              path: 'analog-gauge-reading',
              name: 'ai-vision-analog-gauge-reading',
              component: () => import('@/pages/ai/AnalogGaugeReadingPage.vue'),
              meta: { hideHeader: true }
            },
            {
              path: 'area-entry-detection',
              name: 'ai-vision-area-entry-detection',
              component: () => import('@/pages/ai/AreaEntryDetectionPage.vue'),
              meta: { hideHeader: true }
            }
            // {
            //   path: 'moge',
            //   name: 'ai-vision-moge',
            //   component: () => import('@/pages/ai/Moge2Page.vue'),
            // }
          ]
        }
      ]
    },
    {
      path: '/usecase',
      name: 'usecase',
      component: () => import('@/shared/ui/layouts/UseCaseLayout.vue'),
      meta: {
        title: 'Use Case | CoMake'
      },
      redirect: '/usecase/smartPole',
      children: [
        {
          path: 'smartPole',
          name: 'usecase-smartPole',
          redirect: '/usecase/smartPole/main',
          children: [
            {
              path: 'main',
              name: 'usecase-smartPole-main',
              component: () => import('@/pages/usecase/SmartPolePage.vue')
            },
            {
              path: 'field',
              name: 'usecase-smartPole-field',
              component: () => import('@/pages/usecase/SmartPoleFieldPage.vue')
            }
          ]
        },
        {
          path: 'sensors',
          name: 'usecase-sensors',
          redirect: '/usecase/sensors/kanavi',
          children: [
            {
              path: 'kanavi',
              name: 'usecase-sensors-kanavi',
              component: () => import('@/pages/usecase/KanaviLidarPage.vue')
            },
            {
              path: 'demo360',
              name: 'usecase-sensors-demo360',
              component: () => import('@/pages/usecase/Demo360Page.vue')
            },
            {
              path: 'phoneRobot',
              name: 'usecase-sensors-phone-robot',
              component: () => import('@/pages/usecase/PhoneRobotPage.vue')
            }
          ]
        },
        {
          path: 'xr',
          name: 'usecase-xr',
          redirect: '/usecase/xr/webxr-demo',
          children: [
            {
              path: 'webxr-demo',
              name: 'usecase-xr-webxr-demo',
              component: () => import('@/pages/usecase/WebXRDemoPage.vue')
            },
            {
              path: 'scout-xr',
              name: 'usecase-xr-scout-xr',
              component: () => import('@/pages/usecase/DemoScoutXR.vue')
            },
            {
              path: 'so-arm-go2-xr',
              name: 'usecase-xr-so-arm-go2-xr',
              component: () => import('@/pages/usecase/SoArmGo2XRPage.vue')
            },
            {
              path: 'so-arm-go2-mock',
              name: 'usecase-xr-so-arm-go2-mock',
              component: () => import('@/pages/usecase/SoArmGo2MockDevice.vue')
            },
            {
              path: 'a1-piperx-xr',
              name: 'usecase-xr-a1-piperx-xr',
              component: () => import('@/pages/usecase/A1PiperXXRPage.vue')
            }
          ]
        },
        {
          path: 'demo',
          name: 'usecase-demo',
          component: () => import('@/pages/usecase/DemoPage.vue')
        },
        {
          path: 'demo-pub',
          name: 'usecase-demo-pub',
          component: () => import('@/pages/usecase/DemoPubPage.vue')
        }
      ]
    },
    {
      path: '/usecase/sensors/cctv',
      name: 'usecase-sensors-cctv',
      component: () => import('@/pages/usecase/CCTVPage.vue'),
      meta: { hideHeader: true }
    },
    {
      path: '/usecase/smart-pole',
      name: 'usecase-smart-pole',
      component: () => import('@/pages/usecase/SmartPolePage.vue'),
      meta: { hideHeader: true, padding: true }
    },
    {
      path: '/usecase/scout-xr',
      name: 'usecase-scout-xr',
      component: () => import('@/pages/usecase/DemoScoutXR.vue'),
      meta: { hideHeader: true }
    },
    {
      path: '/lab',
      name: 'lab',
      component: () => import('@/shared/ui/layouts/LabLayout.vue'),
      children: [
        {
          path: '360Video',
          name: 'lab-360Video',
          component: () => import('@/pages/lab/360VideoPage.vue')
        },
        {
          path: 'recordVideo',
          name: 'lab-recordVideo',
          component: () => import('@/pages/lab/RecordVideoPage.vue')
        },
        {
          path: 'transcode',
          name: 'lab-transcode',
          component: () => import('@/pages/lab/TranscodePage.vue')
        },
        {
          path: 'graphicSend',
          name: 'lab-graphicSend',
          component: () => import('@/pages/lab/GraphicDataSendPage.vue')
        },
        {
          path: 'tracking',
          name: 'lab-tracking',
          component: () => import('@/pages/lab/deviceTrackingPage.vue')
        },
        {
          path: 'multiServer',
          name: 'lab-multiServer',
          component: () => import('@/pages/lab/MultiServerPage.vue')
        },
        {
          path: 'recordWebVideo',
          name: 'lab-recordWebVideo',
          component: () => import('@/pages/lab/RecordWebVideoPage.vue')
        },
        {
          path: 'webTransport',
          name: 'lab-webTransport',
          component: () => import('@/pages/lab/WebTransportPage.vue')
        },
        {
          path: 'serverTrafficCheck',
          name: 'lab-serverTrafficCheck',
          component: () => import('@/pages/lab/ServerTrafficCheckPage.vue')
        },
        {
          path: 'multiServerManagement',
          name: 'lab-multiServerManagement',
          component: () => import('@/pages/lab/MultiServerManagementPage.vue')
        },
        {
          path: 'mediaPacket',
          name: 'lab-mediaPacket',
          component: () => import('@/pages/lab/MediaPacketPage.vue')
        },
        {
          path: 'mimeTest',
          name: 'lab-mimeTest',
          component: () => import('@/pages/lab/MimeTestPage.vue')
        },
        {
          path: 'rateControlPub',
          name: 'lab-rateControlPub',
          component: () => import('@/pages/lab/RateControlPubPage.vue')
        },
        {
          path: 'rateControlSub',
          name: 'lab-rateControlSub',
          component: () => import('@/pages/lab/RateControlSubPage.vue')
        },
        {
          path: 'e2eSecurity',
          name: 'lab-e2eSecurity',
          component: () => import('@/pages/lab/SecurePacketPage.vue')
        },
        {
          path: 'autoResolutionPub',
          name: 'lab-autoResolutionPub',
          component: () => import('@/pages/lab/AutoResolutionPubPage.vue')
        },
        {
          path: 'autoResolutionSub',
          name: 'lab-autoResolutionSub',
          component: () => import('@/pages/lab/AutoResolutionSubPage.vue')
        },
        {
          path: 'termiteVideoPub',
          name: 'lab-termiteVideoPub',
          component: () => import('@/pages/lab/TermiteVideoPubPage.vue')
        },
        {
          path: 'gaussianSplatting',
          name: 'lab-gaussianSplatting',
          component: () => import('@/pages/lab/GaussianSplattingPage.vue')
        },
        {
          path: 'handShapeController',
          name: 'lab-handShapeController',
          component: () => import('@/pages/lab/HandShapeControllerPage.vue')
        },
        {
          path: 'mujoco',
          name: 'lab-mujoco',
          component: () => import('@/pages/lab/MujocoPage.vue')
        },
        {
          path: 'pointCloudNavigation',
          name: 'lab-pointCloudNavigation',
          component: () => import('@/pages/lab/Navigation3DPage.vue')
        }
      ]
    },
    {
      path: '/:catchAll(.*)*',
      name: 'not-found',
      component: () => import('@/pages/NotFoundPage.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title as string
  } else {
    document.title = "CoMake | Let's Make Together"
  }
  next()
})

export default router
